import { createSlice } from "@reduxjs/toolkit";
import {
  AddHelpAndFeedbackAction,
  DeleteHelpAndFeedbackAction,
  GetAllHelpAndFeedbackAction,
  UpdateHelpAndFeedbackAction,
} from "store/middlewares/dataManagement/helpAndFeedback";

export const helpAndFeedbackSlice = createSlice({
  name: "helpAndFeedback",
  initialState: {
    helpAndFeedbackLoading: false,
    helpAndFeedback: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllHelpAndFeedbackAction.pending, (state) => {
        state.helpAndFeedbackLoading =
          state.helpAndFeedback?.data?.length > 0 ? false : true;
        state.helpAndFeedback =
          state.helpAndFeedback?.data?.length > 0
            ? state.helpAndFeedback
            : null;
      })
      .addCase(GetAllHelpAndFeedbackAction.fulfilled, (state, action) => {
        state.helpAndFeedbackLoading = false;
        state.helpAndFeedback = action.payload.response;
      })
      .addCase(GetAllHelpAndFeedbackAction.rejected, (state) => {
        state.helpAndFeedbackLoading = false;
        state.helpAndFeedback = null;
      })

      .addCase(DeleteHelpAndFeedbackAction.fulfilled, (state, action) => {
        state.helpAndFeedbackLoading = false;
        state.helpAndFeedback = action.payload.response;
      })

      .addCase(UpdateHelpAndFeedbackAction.fulfilled, (state, action) => {
        state.helpAndFeedbackLoading = false;
        state.helpAndFeedback = {
          ...state.helpAndFeedback,
          data: state.helpAndFeedback.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item,
          ),
        };
      })

      .addCase(AddHelpAndFeedbackAction.fulfilled, (state, action) => {
        state.helpAndFeedbackLoading = false;
        state.helpAndFeedback = action.payload.response;
      });
  },
});

export default helpAndFeedbackSlice.reducer;
